<template>
    <div>
        <PageSpinner :onloader="onloader" />
        <card header-classes="bg-transparent">
            <div class="card">
                <div class=" card-header">
                    <h3 class=" card-title">Mid Term Report Card</h3>
                </div>
                <div class="card-body">
                    <div class="form-inline text-center">

                        <select v-model="RegisteredTermIdVal" class="form-control ml-3"
                            :disabled="RegisteredTerms === null" @change="GetStudentForReportCardMidTerm()">
                            <option value="0">{{ RegisteredTerms === null ? '⏳ Loading...' : '- Select Registered Term-' }}</option>
                            <option v-for="item in RegisteredTerms" :key="item.registeredTermId"
                                v-bind:value="item.registeredTermId">
                                {{ item.schSession }} - {{ item.schTerm }}
                            </option>
                        </select>
                        <select v-model="ClassIdval" class="form-control ml-3"
                            @change="getoption(); GetStudentForReportCardMidTerm()" :disabled="schclass === null">
                            <option value="0">{{ schclass === null ? '⏳ Loading...' : '- Select Class -'
                                }}</option>
                            <option v-for="item in schclass" :key="item.Id" v-bind:value="item.Id">
                                {{ item.Sch_Class }}
                            </option>
                        </select>
                        <select v-model="OptionIdval" class="form-control ml-3"
                            @change="getarm(); GetStudentForReportCardMidTerm()" :disabled="optionitems === null">
                            <option value="0">{{ optionitems === null ? '⏳ Loading...' : '- Select Option -'
                                }}</option>
                            <option v-for="item in optionitems" :key="item.Id" v-bind:value="item.Id">
                                {{ item.ClassOption }}
                            </option>
                        </select>
                        <select v-model="ArmIdval" class="form-control ml-3" @change="GetStudentForReportCardMidTerm()"
                            :disabled="armitems === null">
                            <option value="0">{{ armitems === null ? '⏳ Loading...' : '- Select Arm -'
                                }}</option>
                            <option v-for="item in armitems" :key="item.subjectId" v-bind:value="item.subjectId">
                                {{ item.SectionName }}
                            </option>
                        </select>
                        <div class="justify-content-end form-inline my-3">
                            <base-input class="input-group-alternative" placeholder="Search here..."
                                addon-left-icon="fa fa-search" v-model="searchval">
                            </base-input>
                        </div>
                    </div>
                    <div class="row" v-if="RegisteredTermIdVal">
                        <div class="col-lg-3" v-for="item in searchedResultQuery" :key="item.studentId">
                            <div class="card text-center m-2 animate__animated animate__flipInX">
                                <div class="card-body bg-success">
                                    <img v-if="item.passport" :src="item.passport" class="rounded" alt="" height="50" />
                                    <img v-else src="/img/brand/loguser.png" class="rounded" alt="" height="50" />
                                    <h5 class="text-white"><small>{{ item.studentName }}</small> </h5>
                                    <h6 class="text-white"> <small>{{ item.admNo }} | {{ item.className }} | {{
                                        item.classOption
                                            }} |
                                            {{
                                                item.sectionName
                                            }}</small> </h6>
                                    <div>
                                        <button class="btn btn-secondary btn-sm my-2"
                                            v-on:click="GetStudentReportCardMidTerm(item.studentId)">
                                            Print <i class="fa fa-arrow-right"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <modal :show.sync="modals.reportModal" modal-classes="modal-dialog-centered modal-xl modal-dialog-scrollable" body-classes="overflow-auto">
                        <div slot="header" class="modal-title position-relative">
                            <h5 class="mb-0">Report Card</h5>
                            <button type="button" class="btn btn-danger rounded-pill position-absolute" style="top: 0; right: 0; width: 40px; height: 40px; padding: 0; display: flex; align-items: center; justify-content: center; font-size: 18px;" @click="modals.reportModal = false" aria-label="Close">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                        <div class="card bg-secondary border-0 mb-0">
                            <div class="card-body">
                                <PageSpinner :onloader="onloader" />
                                <div id="printContainer">
                                    <div v-if="reportcard" v-html="reportcard"></div>
                                    <div v-else><h1>Loading...</h1></div>
                                </div>
                            </div>
                        </div>
                        <template slot="footer">
                            <base-button type="default" @click="modals.reportModal = false">Cancel
                            </base-button>
                            <button class="btn btn-default" @click.prevent="openCommentForHeadTeacher()">
                                <i class="fa fa-comment"></i> Head Teacher Comment
                            </button>
                            <button class="btn btn-default" @click.prevent="openCommentForClassTeacher()">
                                <i class="fa fa-comment"></i> Class Teacher Comment
                            </button>
                            <button class="btn btn-default" @click="printreport">
                                <i class="fa fa-print"></i> Print
                            </button>
                            <button class="btn btn-default" @click.prevent="sendreport()">
                                <i class="fa fa-print"></i> Send to Guardian
                            </button>
                        </template>
                    </modal>
                    <modal :show.sync="modals.headTeacherCommentModal" modal-classes="modal-dialog-centered modal-lg">
                        <div class="card bg-secondary border-0 mb-0">
                            <div class="card-body">
                                <PageSpinner :onloader="onloader" />
                                <label>Head Teacher Comment</label>
                                <textarea v-model="headteachercommval" class="form-control" placeholder="Enter Comment"
                                    @focus="showHeadSuggestions = true"
                                    @blur="closeHeadSuggestionsDelayed()"></textarea>
                                <div v-show="showHeadSuggestions" class="list-group mt-2">
                                    <button type="button" class="list-group-item list-group-item-action"
                                        v-for="(s, idx) in headTeacherSuggestions" :key="idx"
                                        @mousedown.prevent="selectHeadSuggestion(s)">
                                        {{ s }}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <template slot="footer">
                            <base-button type="dark" @click="modals.headTeacherCommentModal = false">Cancel
                            </base-button>
                            <button class="btn btn-default" @click.prevent="CreateHeadTeacherCommentMid()">
                                Submit
                            </button>
                        </template>
                    </modal>
                    <modal :show.sync="modals.classTeacherCommentModal" modal-classes="modal-dialog-centered modal-lg">
                        <div class="card bg-secondary border-0 mb-0">
                            <div class="card-body">
                                <PageSpinner :onloader="onloader" />
                                <label>Class Teacher Comment</label>
                                <textarea v-model="classteachercommval" class="form-control" placeholder="Enter Comment"
                                    @focus="showClassSuggestions = true"
                                    @blur="closeClassSuggestionsDelayed()"></textarea>
                                <div v-show="showClassSuggestions" class="list-group mt-2">
                                    <button type="button" class="list-group-item list-group-item-action"
                                        v-for="(s, idx) in classTeacherSuggestions" :key="idx"
                                        @mousedown.prevent="selectClassSuggestion(s)">
                                        {{ s }}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <template slot="footer">
                            <base-button type="dark" @click="modals.classTeacherCommentModal = false">Cancel
                            </base-button>
                            <button class="btn btn-default" @click.prevent="CreateClassTeacherReportCommentMid()">
                                Submit
                            </button>
                        </template>
                    </modal>

                </div>
            </div>
        </card>
    </div>
</template>
<script>
import moment from 'moment'
import Alert from "@/mixins/Alert.mixins"
import PageSpinner from "@/components/PageSpinner"
import CheckStaffUser from "@/mixins/CheckStaffUser.mixin"
export default {
    name: 'classattendance',
    mixins: [Alert, CheckStaffUser],
    components: {
        PageSpinner
    },
    data() {
        return {
            dataid: 1,
            RegisteredTermIdVal: 0,
            StudIdval: 0,
            ClassIdval: 0,
            OptionIdval: 0,
            ArmIdval: 0,
            SectionIdval: 0,
            schclass: null,
            optionitems: null,
            armitems: null,
            headteacherval: "",
            headteachercommval: "",
            dateheadteachercomment: null,
            classteacherval: "",
            classteachercommval: "",
            dateclassteachercomment: null,
            headTeacherSuggestions: [
                'Shows excellent progress throughout the term.',
                'Consistent performer; keeps up with classwork.',
                'Needs improvement in class participation.',
                'Demonstrates leadership and cooperates well with peers.',
                'Requires extra support in mathematics.',
                'Homework is consistently submitted on time.'
            ],
            classTeacherSuggestions: [
                'Good grasp of concepts; keep encouraging.',
                'Shows potential but lacks consistency.',
                'Needs to focus more during lessons.',
                'Excellent behavior and attitude in class.',
                'Struggles with attention; recommend remedial sessions.',
                'Participates actively and asks relevant questions.'
            ],
            showHeadSuggestions: false,
            showClassSuggestions: false,
            gradeimagepath: "img/brand/mark.png",
            RegisteredTerms: null,
            studentitems: null,
            schooldetailsitem: null,
            reportheaderrep: null,
            studrep: null,
            reportcard: null,
            currdate: null,
            searchval: "",
            process: "N",
            onloader: "none",
            isopenCommentForHeadTeacher: false,
            isopenCommentForClassTeacher: false,
            modals: {
                reportModal: false,
                headTeacherCommentModal: false,
                classTeacherCommentModal: false
            },
        };
    },
    methods: {
        openCommentForHeadTeacher() {
            this.modals.headTeacherCommentModal = true;
            this.isopenCommentForHeadTeacher = true;
            if (!this.headteachercommval || this.headteachercommval.toString().trim() === '') {
                this.showHeadSuggestions = true;
            }
        },

        openCommentForClassTeacher() {
            this.modals.classTeacherCommentModal = true;
            this.isopenCommentForClassTeacher = true;
            if (!this.classteachercommval || this.classteachercommval.toString().trim() === '') {
                this.showClassSuggestions = true;
            }
        },

        CreateHeadTeacherCommentMid() {
            let StudentId = this.StudIdval;
            let RegisteredTermId = this.RegisteredTermIdVal;
            let Comment = this.headteachercommval;

            let userdata = {
                StudentId,
                RegisteredTermId,
                Comment
            };
            this.onloader = "flex";
            this.$store
                .dispatch("PortalReport/CreateHeadTeacherCommentMid", userdata)
                .then((resp) => {
                    this.GetStudentReportCardMidTerm(StudentId);
                    this.modals.headTeacherCommentModal = false;
                    this.onloader = "none";
                    if (resp.responseCode == "00") {
                        this.ShowAlertSuccess('Submitted Successfully', '');
                    } else {
                        this.ShowAlertError(resp.responseMessage, '');
                    }   
                })
                .catch(err => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        CreateClassTeacherReportCommentMid() {
            let StudentId = this.StudIdval;
            let RegisteredTermId = this.RegisteredTermIdVal;
            let Comment = this.classteachercommval;

            let userdata = {
                StudentId,
                RegisteredTermId,
                Comment
            };
            this.onloader = "flex";
            this.$store
                .dispatch("PortalReport/CreateClassTeacherReportCommentMid", userdata)
                .then((resp) => {
                    this.GetStudentReportCardMidTerm(StudentId);
                    this.modals.classTeacherCommentModal = false;
                    this.onloader = "none";
                   if (resp.responseCode == "00") {
                        this.ShowAlertSuccess('Submitted Successfully', '');
                    } else {
                        this.ShowAlertError(resp.responseMessage, '');
                    }   
                })
                .catch(err => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        sendreport() {
            let StudId = this.StudIdval;
            let SessionId = this.SessionIdval;
            let TermId = this.TermIdval;
            let username = this.$store.state.auth.username;
            let accesskey = this.$store.state.auth.accesskey;
            let userdata = {
                StudId,
                SessionId,
                TermId,
                username,
                accesskey
            };
            this.onloader = "flex";
            this.$store
                .dispatch("sendreport", userdata)
                .then(() => {
                    this.onloader = "none";
                    this.ShowAlertSuccess('Sent Successfully', '');
                })
                .catch(err => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        getcurendate() {
            var today = new Date();
            this.currdate =
                today.getDate() +
                "/" +
                (today.getMonth() + 1) +
                "/" +
                today.getFullYear();
        },
        printreport() {
            const printContents = document.getElementById('printContainer').innerHTML;
            const w = window.open('', '', 'height=600,width=800');
            w.document.write('<html><head><title>Full Term Report Card</title></head><body>');
            w.document.write(printContents);
            w.document.write('</body></html>');
            w.document.close();
            w.print();
        },
        GetStudentReportCardMidTerm(studentId) {
            this.reportcard = null;
            this.StudIdval = studentId;
            let StudentId = studentId;
            let RegisteredTermId = this.RegisteredTermIdVal;

            let userdata = {
                StudentId,
                RegisteredTermId
            };
            this.onloader = "flex";
            this.$store
                .dispatch("PortalReport/GetStudentReportCardMidTerm", userdata)
                .then(resp => {
                    if (resp.responseCode == "00") {
                        this.reportcard = resp.data;
                        this.modals.reportModal = true;
                    } else {
                        this.ShowAlertError(resp.responseMessage, '');
                    }
                    this.onloader = "none";
                })
                .catch(err => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        GetPortalRegisteredTerm() {
            let userdata = {
                SearchValue: null,
                PageNumber: 1,
                PageSize: 100
            }
            this.RegisteredTermIdVal = 0;
            this.onloader = "flex";
            this.$store
                .dispatch("PortalSchoolSessionTerm/GetPortalRegisteredTerm", userdata)
                .then((resp) => {
                    this.RegisteredTerms = resp.data;
                    this.onloader = "none";
                })
                .catch((err) => {
                    console.log(err);
                    this.onloader = "none";
                });
        },
        getclass() {
            this.$store
                .dispatch("getclass")
                .then((resp) => {
                    this.schclass = resp;
                })
                .catch((err) => {
                    this.ShowAlertError(err.response.data, '');
                });
        },
        getoption() {
            let ClassId = this.ClassIdval;
            if (ClassId > 0) {
                this.onloader = "flex";
                this.$store
                    .dispatch("getoptionbyclass", ClassId)
                    .then((resp) => {
                        this.optionitems = resp;
                        this.GetStudentForReportCardMidTerm();
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
        getarm() {
            let ClassId = this.ClassIdval;
            let OptionId = this.OptionIdval;
            let SchArm = "Search";
            let Id = 1;
            let processop = this.process;
            let username = this.$store.state.auth.username;
            let accesskey = this.$store.state.auth.accesskey;
            this.onloader = "flex";
            let payload = {
                Id,
                ClassId,
                OptionId,
                SchArm,
                processop,
                username,
                accesskey,
            };
            this.$store
                .dispatch("getarmbyoption", payload)
                .then((resp) => {
                    this.armitems = resp;
                    this.GetStudentForReportCardMidTerm();
                    this.onloader = "none";
                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        GetStudentForReportCardMidTerm() {
            this.reportcard = null;
            this.studentitems = null;

            let RegisteredTermId = this.RegisteredTermIdVal;
            let ClassId = this.ClassIdval;
            let SectionId = this.SectionIdval
            let OptionId = this.OptionIdval;
            let userData = {
                RegisteredTermId, ClassId, SectionId, OptionId
            }
            if (this.RegisteredTermIdVal > 0) {
                this.onloader = "flex";
                this.$store
                    .dispatch("PortalStudent/GetStudentForReportCardMidTerm", userData)
                    .then(resp => {
                        if (resp.responseCode == "00") {
                            this.studentitems = resp.data;
                        }
                        this.onloader = "none";
                    })
                    .catch(err => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            } else {
                this.ShowAlertError('Please select Registered Term', '');
            }
        },
        getstudentbyid() {
            let StudId = this.StudIdval;
            if (StudId > 0) {
                this.onloader = "flex";
                this.$store
                    .dispatch("getstudentbyid", StudId)
                    .then(resp => {
                        this.studrep = resp;
                        this.onloader = "none";
                    })
                    .catch(err => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
        frontEndDateFormat(date) {
            return moment(date).format("YYYY-MM-DD");
        },
        backEndDateFormat(date) {
            return moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");
        },

        selectHeadSuggestion(text) {
            if (!this.headteachercommval || this.headteachercommval.toString().trim() === '') {
                this.headteachercommval = text;
            } else {
                this.headteachercommval = this.headteachercommval.trim() + '\n' + text;
            }
            this.showHeadSuggestions = false;
        },

        selectClassSuggestion(text) {
            if (!this.classteachercommval || this.classteachercommval.toString().trim() === '') {
                this.classteachercommval = text;
            } else {
                this.classteachercommval = this.classteachercommval.trim() + '\n' + text;
            }
            this.showClassSuggestions = false;
        },

        closeHeadSuggestionsDelayed() {
            setTimeout(() => {
                this.showHeadSuggestions = false;
            }, 150);
        },

        closeClassSuggestionsDelayed() {
            setTimeout(() => {
                this.showClassSuggestions = false;
            }, 150);
        },

    },
    watch: {
        'modals.headTeacherCommentModal'(val) {
            if (val && (!this.headteachercommval || this.headteachercommval.toString().trim() === '')) {
                this.showHeadSuggestions = true;
            } else {
                this.showHeadSuggestions = false;
            }
        },
        'modals.classTeacherCommentModal'(val) {
            if (val && (!this.classteachercommval || this.classteachercommval.toString().trim() === '')) {
                this.showClassSuggestions = true;
            } else {
                this.showClassSuggestions = false;
            }
        },
        isopenCommentForHeadTeacher(val) {
            if (val && (!this.headteachercommval || this.headteachercommval.toString().trim() === '')) {
                this.showHeadSuggestions = true;
            } else {
                this.showHeadSuggestions = false;
            }
        },
        isopenCommentForClassTeacher(val) {
            if (val && (!this.classteachercommval || this.classteachercommval.toString().trim() === '')) {
                this.showClassSuggestions = true;
            } else {
                this.showClassSuggestions = false;
            }
        }
    },
    computed: {
        searchedResultQuery() {
            if (this.searchval) {
                return this.studentitems.filter(item => {
                    return this.searchval
                        .toLowerCase()
                        .split(" ")
                        .every(
                            v =>
                                item.studentName.toLowerCase().includes(v) ||
                                item.className.toLowerCase().includes(v) ||
                                item.classOption.toLowerCase().includes(v) ||
                                item.sectionName.toLowerCase().includes(v) ||
                                item.admNo.toLowerCase().includes(v)
                        );
                });
            } else {
                return this.studentitems;
            }
        }
    },
    mounted() {
        this.GetPortalRegisteredTerm();
        this.getcurendate();
        this.getclass();
    }
};
</script>

<style>
.borderall {
    text-align: center;
    border: 3px solid #000;
}

.bordercol {
    text-align: center;
    padding-left: 5px;
    padding-right: 5px;
    border: thin solid #000;
}

.padbody {
    padding: 20px;
}

.padhead {
    padding: 5px;
    border: 3px solid #606060;
}

.pad {
    padding: 10px;
}

table {
    font-size: 9pt;
    width: 100%;
}

.bodytext {
    font-size: 9pt;
}
</style>
